/// <amd-module name="Core/Medius.Core.Web/Scripts/Medius/apps/spaManager/route" />

class Route {
    constructor(public path: string, public action: (...args: (string | number)[]) => void) {}
}

export function create(path: string, action: (...args: (string | number)[]) => void): Route {
    return new Route(path, action);
}